import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingSkeleton from "./components/loading.js";
import ProtectedRoute from "./scripts/protectedRoute";

const Home = React.lazy(() => import("./pages/dashboard/home/home.js"));
const Logs = React.lazy(() => import("./pages/logs/logs"));
const Ativos = React.lazy(() => import("./pages/register/assets/assets.js"));
const Usuarios = React.lazy(() => import("./pages/register/users/users.js"));
const UsuariosGrupo = React.lazy(
  () => import("./pages/register/users/groups/usersGroups.js"),
);
const Perfil = React.lazy(() => import("./pages/profiles/profiles.js"));
const Detalhes = React.lazy(
  () => import("./pages/dashboard/details/detailsGeneral.js"),
);
const Login = React.lazy(() => import("./pages/login/login.js"));
const EsqueceuSenha = React.lazy(
  () => import("./pages/login/forgotPassword.js"),
);
const SemPermissao = React.lazy(
  () => import("./components/pageNoPermission.js"),
);
const NaoEncontrada = React.lazy(() => import("./components/pageNotFound.js"));

const AppRoutes = () => (
  <Suspense fallback={<LoadingSkeleton />}>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/esqueceuSenha" element={<EsqueceuSenha />} />
      <Route path="/semPermissao" element={<SemPermissao />} />
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            <Home analized={false} />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/amostrasanalisadas"
        element={
          <ProtectedRoute>
            <Home analized={true} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ativos"
        element={
          <ProtectedRoute module="register" action="devices">
            <Ativos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute module="register" action="users">
            <Usuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute module="actions" action="logsView">
            <Logs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios/grupo"
        element={
          <ProtectedRoute module="register" action="users">
            <UsuariosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="/detalhes/:sampleProtocol"
        element={
          <ProtectedRoute>
            <Detalhes />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NaoEncontrada />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
